/**
 * Detect all-white / near-uniform PNG frames (common Playwright headless glitch).
 * Returns true if the image is likely blank — caller should refresh the screenshot.
 */
export function isLikelyBlankWhitePngBase64(b64) {
  if (!b64 || typeof b64 !== 'string' || b64.length < 200) return true;

  return new Promise((resolve) => {
    const img = new Image();
    const done = (blank) => resolve(blank);

    img.onload = () => {
      try {
        const nw = img.naturalWidth || 1;
        const nh = img.naturalHeight || 1;
        const w = Math.min(48, nw);
        const h = Math.min(36, nh);
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        if (!ctx) {
          done(false);
          return;
        }
        ctx.drawImage(img, 0, 0, w, h);
        const { data } = ctx.getImageData(0, 0, w, h);
        let sum = 0;
        let sumSq = 0;
        let n = 0;
        for (let i = 0; i < data.length; i += 16) {
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];
          const y = 0.299 * r + 0.587 * g + 0.114 * b;
          sum += y;
          sumSq += y * y;
          n++;
        }
        if (!n) {
          done(false);
          return;
        }
        const mean = sum / n;
        const variance = Math.max(0, sumSq / n - mean * mean);
        const blank = mean > 242 && variance < 22;
        done(blank);
      } catch (_) {
        done(false);
      }
    };

    img.onerror = () => done(false);

    try {
      img.src = `data:image/png;base64,${b64.replace(/\s/g, '')}`;
    } catch (_) {
      done(false);
    }
  });
}
